var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4199C24.8366 32.4199 32 25.2565 32 16.4199C32 7.58337 24.8366 0.419922 16 0.419922C7.16344 0.419922 0 7.58337 0 16.4199C0 25.2565 7.16344 32.4199 16 32.4199Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.419922C9.65689 0.419922 4.17589 4.11148 1.58789 9.46342H30.4126C27.8246 4.11148 22.3436 0.419922 16.0003 0.419922Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 32.42C22.3436 32.42 27.8246 28.7284 30.4126 23.3765H1.58789C4.17589 28.7284 9.65689 32.42 16.0003 32.42Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.9849C19.0736 21.9849 21.5652 19.4932 21.5652 16.4197C21.5652 13.3461 19.0736 10.8545 16 10.8545C12.9264 10.8545 10.4348 13.3461 10.4348 16.4197C10.4348 19.4932 12.9264 21.9849 16 21.9849Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 19.8979C17.9207 19.8979 19.478 18.3406 19.478 16.4197C19.478 14.4987 17.9207 12.9414 15.9997 12.9414C14.0787 12.9414 12.5215 14.4987 12.5215 16.4197C12.5215 18.3406 14.0787 19.8979 15.9997 19.8979Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 12.1279L17.0733 14.5616L19.7173 14.274L18.1463 16.4201L19.7173 18.5661L17.0733 18.2786L16.0003 20.7122L14.9272 18.2786L12.2832 18.5661L13.8542 16.4201L12.2832 14.274L14.9272 14.5616L16.0003 12.1279Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.419922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIndia);
export default __webpack_public_path__ + "static/media/flag_india.a9f4369fea7779ee8d9a00cac32ac846.svg";
export { ForwardRef as ReactComponent };